/**
 * Menu Module
 * 
 * Click handlers for all things menu related.
 */

export default class Menu {
	constructor() {
		this.getDomElements()

		if (!this.dom.menuTrigger || !this.dom.menu || !this.dom.header || !this.dom.logo || !this.dom.body) return
		
		this.init()
	}


	init() {
		this.dom.menuTrigger.classList.add('isLoaded')
		this.handleClickEvents()
	}


	handleClickEvents() {
		this.dom.menuTrigger.addEventListener('click', () => {
			window.scrollTo(0, 0)

			this.dom.menuTrigger.classList.toggle('isActive')
			this.dom.menu.classList.toggle('isActive')
			this.dom.header.classList.toggle('isActive')
			this.dom.logo.classList.toggle('isActive')
			this.dom.body.classList.toggle('u-locked')
			this.dom.html.classList.toggle('u-locked')
		})
	}


	getDomElements() {
		this.dom = {
			menuTrigger: document.querySelector('.js-mobile-trigger'),
			menu: document.querySelector('.js-mobile-menu'),
			logo: document.querySelector('.js-site-logo'),
			header: document.querySelector('.js-header'),
			body: document.querySelector('body'),
			html: document.querySelector('html'),
		}
	}
};